import type { TermsLegal } from "./types";

export const termsCs: TermsLegal = {
  heroPill:
    "Verze 2.0.1 · zveřejněno 25. října 2026 · pro stávající Zákazníky od 15. listopadu 2026",
  title: "Obchodní podmínky",
  subtitle: "Služby Zettl",
  bindingNote: null,
  articles: [
    {
      title: "Úvodní ustanovení",
      clauses: [
        {
          text: "Tyto obchodní podmínky (dále jen „Podmínky“) upravují práva a povinnosti mezi společností IDEx Corporate s.r.o., IČO 18002161, se sídlem Kurzova 2222/16, Stodůlky, 155 00 Praha 5, zapsanou v obchodním rejstříku vedeném Městským soudem v Praze, oddíl C, vložka 379847 (dále jen „Poskytovatel“), a Zákazníkem při poskytování a užívání služby Zettl.",
        },
        {
          text: "Poskytovatel není plátcem daně z přidané hodnoty. Kontaktní e-mail Poskytovatele je [info@idex-corp.com](mailto:info@idex-corp.com).",
        },
        {
          text: "Podmínky jsou součástí smlouvy o poskytování Služby uzavřené mezi Poskytovatelem a Zákazníkem (dále jen „Smlouva“). Uzavřou-li strany písemně individuální ujednání, která se od Podmínek odchylují, mají tato ujednání přednost.",
        },
        {
          text: "Otázky, které Smlouva ani Podmínky neupravují, se řídí právním řádem České republiky, zejména zákonem č. 89/2012 Sb., občanský zákoník (dále jen „občanský zákoník“).",
        },
      ],
    },
    {
      title: "Definice",
      clauses: [
        {
          text: "Pojmy s velkým počátečním písmenem mají v Podmínkách tento význam:",
          items: [
            "„Služba“ je webová aplikace Zettl dostupná na app.zettl.cz včetně konektoru MCP, poskytovaná jako software jako služba (SaaS).",
            "„Zákazník“ je podnikatel podle čl. 4, který s Poskytovatelem uzavřel Smlouvu.",
            "„Uživatel“ je fyzická osoba, která Službu užívá pod vlastním přihlášením jménem Zákazníka, včetně osob, které Zákazník do Služby přizve (například jeho účetní).",
            "„Účet“ je přístup Uživatele ke Službě chráněný přihlašovacími údaji.",
            "„Organizace“ je pracovní prostor Služby pro jednu firmu Zákazníka, do kterého lze přizvat další Uživatele.",
            "„Tarif“ je placený program Služby (v současnosti Start a Firma) s rozsahem funkcí a limity podle Ceníku.",
            "„Ceník“ je přehled Tarifů, cen a limitů zveřejněný na [zettl.cz v sekci Ceník](/#cenik).",
            "„Zúčtovací období“ je jeden měsíc, počítaný ode dne, kdy předplatné Tarifu začalo.",
            "„Zkušební doba“ je bezplatné vyzkoušení Služby podle čl. 7.",
            "„Data Zákazníka“ jsou veškerá data, která do Služby vloží Zákazník nebo Uživatelé nebo která Služba na jejich pokyn získá, zejména bankovní transakce, doklady, faktury, údaje o klientech, rozpočty a soubory.",
            "„Režim pouze pro čtení“ je stav, v němž lze Data Zákazníka prohlížet a exportovat, ale nelze stahovat nové transakce, nahrávat doklady ani nechat doklady číst pomocí AI.",
          ],
        },
      ],
    },
    {
      title: "Uzavření Smlouvy a komunikace",
      clauses: [
        {
          text: "Zákazník se ke Službě registruje na app.zettl.cz. Smlouva je uzavřena dokončením registrace.",
        },
        {
          text: "Před odesláním žádosti nebo dokončením registrace vyjádří Zákazník souhlas s Podmínkami zaškrtnutím příslušného pole. Na požádání Poskytovatel Zákazníkovi zašle znění Podmínek, které platilo v okamžiku uzavření Smlouvy.",
        },
        {
          text: "Kdo za Zákazníka žádá o přístup, registruje se, přijímá Podmínky nebo objednává Tarif, prohlašuje, že je k tomu oprávněn.",
        },
        {
          text: "Smlouvu nelze uzavřít přijetím návrhu s dodatkem nebo odchylkou; ustanovení § 1740 odst. 3 občanského zákoníku se nepoužije.",
        },
        {
          text: "Smlouva se uzavírá na dobu neurčitou. Placený Tarif se sjednává vždy na jedno Zúčtovací období a automaticky se obnovuje podle čl. 8.",
        },
        {
          text: "Strany spolu komunikují elektronicky: Poskytovatel na e-mailovou adresu Účtu, který Tarif objednal nebo Organizaci založil, a oznámeními ve Službě; Zákazník na [info@idex-corp.com](mailto:info@idex-corp.com). Zpráva zaslaná e-mailem se považuje za doručenou následující pracovní den po odeslání. Zákazník udržuje svou e-mailovou adresu aktuální.",
        },
      ],
    },
    {
      title: "Kdo může Službu užívat",
      clauses: [
        {
          text: "Služba je určena výhradně podnikatelům: obchodním společnostem, jiným právnickým osobám a fyzickým osobám, které Službu užívají v rámci své podnikatelské činnosti nebo při samostatném výkonu svého povolání. Služba není určena spotřebitelům.",
        },
        {
          text: "Zákazník při uzavření Smlouvy prohlašuje, že je podnikatelem a Službu užívá pro účely svého podnikání. Ustanovení právních předpisů na ochranu spotřebitele se proto na Smlouvu nepoužijí. Poskytovatel může Zákazníka požádat o IČO a ověřit je ve veřejném rejstříku.",
        },
        {
          text: "Soukromý režim Služby (osobní rozpočet pravidelných výdajů) je doplňkovou funkcí Služby sjednané podnikatelem. Jeho užíváním se ze Zákazníka nestává spotřebitel.",
        },
        {
          text: "Uživatelem může být jen osoba starší 18 let. Uživatele do Služby přizývá Zákazník, zajistí, že dodržují Podmínky, a odpovídá za jejich jednání ve Službě jako za své vlastní.",
        },
      ],
    },
    {
      title: "Služba",
      clauses: [
        {
          text: "Služba umožňuje v rozsahu zvoleného Tarifu zejména:",
          items: [
            "stahovat pohyby z účtů u Fio banky přes rozhraní API Fio banky a nahrávat bankovní výpisy ve formátech GPC/ABO a CSV;",
            "číst údaje z dokladů (účtenek a faktur) pomocí umělé inteligence (dále jen „AI“), včetně dokladů přeposlaných e-mailem;",
            "automaticky párovat platby s doklady a s vystavenými fakturami;",
            "vystavovat faktury s QR platbou a s načtením údajů o firmě z registru ARES;",
            "vést rozpočet pravidelných plateb a analytiku příjmů a výdajů;",
            "připravovat podklady pro účetní (balíček dokladů v PDF, exporty CSV, XLSX a ISDOC);",
            "připojit AI asistenta přes protokol MCP (čl. 11.4).",
          ],
        },
        {
          text: "Poskytovatel Službu průběžně vyvíjí a může měnit, doplňovat nebo odebírat její funkce. Odebrání nebo podstatné omezení funkce, kterou Ceník u Tarifu Zákazníka uvádí, oznámí Zákazníkovi nejméně 30 dní předem. Zákazník pak může Smlouvu vypovědět s účinností ke dni změny; Poskytovatel mu vrátí poměrnou část předem zaplacené ceny za období po zániku Smlouvy.",
        },
        {
          text: "Poskytovatel vynakládá přiměřené úsilí, aby Služba byla dostupná nepřetržitě, dostupnost ani dobu odezvy však nezaručuje. Služba může být přerušena kvůli údržbě a aktualizacím, výpadkům služeb třetích stran (zejména Fio banky a poskytovatelů hostingu a AI) nebo vyšší moci. Plánovanou údržbu provádí Poskytovatel pokud možno mimo pracovní dobu a delší odstávky oznamuje předem ve Službě nebo e-mailem.",
        },
        {
          text: "Čtení dokladů pomocí AI a párování probíhají automaticky a jejich výsledky mohou být chybné nebo neúplné. Párování, jehož skóre shody dosáhne alespoň 70 ze 100, Služba použije automaticky, bez potvrzení Uživatelem; na základě ověřené příchozí platby může také označit vystavenou fakturu jako uhrazenou. Párování dokladu s platbou lze ve Službě jedním kliknutím zrušit; fakturu, kterou Služba označila jako uhrazenou, vrátíte změnou jejího stavu. Zákazník je povinen výsledky (přečtené údaje, párování a stavy faktur) zkontrolovat dříve, než je použije, zejména v účetnictví nebo v daňových podáních.",
        },
        {
          text: "Služba není účetním ani daňovým poradenstvím a nenahrazuje účetní, daňového poradce ani vedení účetnictví podle zákona č. 563/1991 Sb., o účetnictví. Za správnost účetnictví a daňových podání a za archivaci dokladů po dobu stanovenou právními předpisy odpovídá Zákazník.",
        },
        {
          text: "Poskytovatel není propojen s Fio bankou, a.s., a Služba není jejím produktem. Napojení využívá rozhraní API, které Fio banka poskytuje svým klientům. Token pro API si Zákazník vytváří ve svém internetovém bankovnictví, rozhoduje o jeho oprávněních a odpovídá za jeho ochranu. Službě stačí token s oprávněním pouze ke sledování účtu; Poskytovatel doporučuje jiný token nepoužívat. Služba token ukládá šifrovaně a používá jej jen ke stahování pohybů. Zákazník může token kdykoli ve Službě odebrat nebo jej zneplatnit ve svém bankovnictví.",
        },
        {
          text: "Podporu poskytuje Poskytovatel e-mailem na [info@idex-corp.com](mailto:info@idex-corp.com) v pracovní dny, bez garantované doby odezvy. Dotazy Zákazníků s Tarifem Firma vyřizuje přednostně.",
        },
      ],
    },
    {
      title: "Tarify a ceny",
      clauses: [
        {
          text: "Po skončení Zkušební doby lze Službu v plném rozsahu užívat jen v rámci placeného Tarifu nebo bezplatného přístupu podle čl. 6.6. Funkce Tarifů, jejich ceny a limity (zejména počet firem, účtů u Fio banky, Uživatelů a dokladů přečtených pomocí AI za měsíc) stanoví Ceník platný v okamžiku objednání nebo obnovení Tarifu.",
        },
        {
          text: "Ceny jsou uvedeny v korunách českých a jsou konečné. Poskytovatel není plátcem DPH, a DPH proto neúčtuje.",
        },
        {
          text: "Dosáhne-li Zákazník limitu svého Tarifu, může Služba odmítnout přidání dalšího účtu, Uživatele, firmy nebo dokladu ke čtení pomocí AI, dokud Zákazník nepřejde na vyšší Tarif nebo nezačne další kalendářní měsíc. Prohlížení a export Dat Zákazníka limity nikdy neomezují.",
        },
        {
          text: "Poskytovatel může ceny a limity Tarifů měnit. Změnu, která je pro Zákazníka nevýhodná, oznámí Zákazníkovi e-mailem nejméně 30 dní předem a uplatní ji nejdříve od prvního Zúčtovacího období, které začne po její účinnosti. Nesouhlasí-li Zákazník se změnou, může předplatné zrušit ke konci běžícího Zúčtovacího období (čl. 9.4); pokud tak neučiní, platí, že změnu přijal.",
        },
        {
          text: "Stane-li se Poskytovatel plátcem DPH, oznámí Zákazníkovi nejméně 30 dní předem, zda zůstanou ceny konečné, nebo se k nim připočte DPH. Připočtení DPH je změnou ceny podle čl. 6.4; do jejího uplatnění nese DPH Poskytovatel.",
        },
        {
          text: "Poskytovatel může vybraným Zákazníkům (například partnerům) poskytnout bezplatný přístup k Tarifu, na dobu neurčitou nebo na stanovenou dobu. Bezplatný přístup není placeným Tarifem: Zákazník za něj nic neplatí a čl. 8 a 9 se na něj nepoužijí. Rozsah funkcí a limity se řídí Tarifem, ke kterému byl přístup poskytnut. Na bezplatný přístup není právní nárok.",
        },
        {
          text: "Bezplatný přístup na stanovenou dobu končí jejím uplynutím. Bezplatný přístup na dobu neurčitou může Poskytovatel ukončit oznámením zaslaným Zákazníkovi e-mailem nejméně 30 dní předem. Po skončení bezplatného přístupu může Zákazník objednat placený Tarif; jinak přejde Účet do Režimu pouze pro čtení a Data Zákazníka se uchovávají podle čl. 10.3.",
        },
        {
          text: "Zákazníci, kteří Službu užívali před spuštěním placených Tarifů, mají bezplatný přístup k Tarifu Firma, dokud jim Poskytovatel jeho ukončení neoznámí postupem podle čl. 6.7.",
        },
      ],
    },
    {
      title: "Zkušební doba",
      clauses: [
        {
          text: "Nový Zákazník může Službu 14 dní zdarma vyzkoušet v rozsahu Tarifu Firma. Zkušební doba začíná zpřístupněním Účtu. Platební karta se nevyžaduje.",
        },
        {
          text: "Zkušební dobu lze využít jen jednou na osobu, která ji zahájila; založení další Organizace ji neobnovuje.",
        },
        {
          text: "Neobjedná-li Zákazník do konce Zkušební doby placený Tarif, přejde Účet do Režimu pouze pro čtení. Zákazníkovi tím nevzniká žádná platební povinnost a nic se mu automaticky neúčtuje. Data Zákazníka zůstávají zachována podle čl. 10.3.",
        },
        {
          text: "Objedná-li Zákazník Tarif během Zkušební doby, zbývající dny mu nepropadají: první platba se strhne v den, kdy Zkušební doba skončí. Zbývají-li ze Zkušební doby méně než 2 dny, strhne se první platba již při objednání.",
        },
      ],
    },
    {
      title: "Platby a fakturace",
      clauses: [
        {
          text: "Cena Tarifu se platí předem za každé Zúčtovací období. Platby zpracovává platební brána Stripe (Stripe Payments Europe, Ltd., Irsko). Údaje o platební kartě zadává Zákazník přímo platební bráně; Poskytovatel k nim nemá přístup. Platit lze platební kartou a dalšími způsoby, které platební brána nabídne.",
        },
        {
          text: "Předplatné se na konci každého Zúčtovacího období automaticky obnovuje na další Zúčtovací období a cena se strhne z uložené platební metody, dokud Zákazník předplatné nezruší (čl. 9.4). Objednáním Tarifu Zákazník s opakovaným strháváním plateb souhlasí.",
        },
        {
          text: "O každé přijaté platbě vystaví Poskytovatel účetní doklad. Poskytovatel není plátcem DPH, doklad proto není daňovým dokladem. Doklad Poskytovatel zasílá e-mailem a je dostupný také v zákaznickém portálu platební brány, do kterého se vstupuje ze Služby. Zákazník souhlasí s elektronickou formou dokladů a odpovídá za správnost fakturačních údajů (název, sídlo, IČO), které uvede.",
        },
        {
          text: "Nepodaří-li se platbu strhnout, platební brána ji v následujících dnech opakuje a Poskytovatel Zákazníka e-mailem vyzve k aktualizaci platební metody. Po dobu nejméně 14 dní od splatnosti funguje Služba v plném rozsahu. Není-li cena uhrazena ani po uplynutí této lhůty, přejde Účet do Režimu pouze pro čtení; po zaplacení se plný přístup obnoví.",
        },
        {
          text: "Cena zaplacená za započaté Zúčtovací období se nevrací, ani když Zákazník Službu přestane užívat nebo předplatné zruší před koncem období. To neplatí v případech, kdy Podmínky vrácení poměrné části ceny výslovně stanoví (čl. 5.2, 13.3 a 16.3), nebo kdy to vyžaduje právní předpis.",
        },
      ],
    },
    {
      title: "Změna Tarifu a zrušení předplatného",
      clauses: [
        {
          text: "Zákazník může Tarif kdykoli sám změnit v nastavení Služby.",
        },
        {
          text: "Přechod na vyšší Tarif se projeví okamžitě. Za zbývající část běžícího Zúčtovacího období se doplácí poměrný rozdíl ceny, který platební brána vyúčtuje hned nebo s nejbližší platbou. Při přechodu na nižší Tarif se nevyčerpaná část ceny převede na kredit, o který se sníží další platby; kredit se nevyplácí.",
        },
        {
          text: "Po přechodu na nižší Tarif zůstanou zachována i data nad jeho rámec (například další firmy, vystavené faktury nebo rozpočty) a lze je dál prohlížet a exportovat. Nové položky nad rámec nižšího Tarifu však vytvářet nelze.",
        },
        {
          text: "Zákazník může předplatné kdykoli sám zrušit v nastavení Služby. Zrušení je účinné ke konci běžícího Zúčtovacího období: do té doby Služba funguje v plném rozsahu a další platba se již nestrhne. Poté přejde Účet do Režimu pouze pro čtení. Do konce Zúčtovacího období může Zákazník zrušení vzít zpět.",
        },
        {
          text: "Zrušením předplatného se nesmaže Účet ani Data Zákazníka (čl. 10.3). Účet může Zákazník kdykoli smazat v nastavení Služby; smazáním Účtu Smlouva zaniká.",
        },
      ],
    },
    {
      title: "Data Zákazníka",
      clauses: [
        {
          text: "Data Zákazníka patří Zákazníkovi. Poskytovatel je zpracovává jen v rozsahu nezbytném k poskytování Služby, k zajištění její bezpečnosti a k plnění svých právních povinností. Data Zákazníka neprodává, nevyužívá k jiným účelům a nepoužívá je k trénování modelů AI.",
        },
        {
          text: "Zákazník může Data Zákazníka kdykoli exportovat (export dat ve formátu JSON, exporty faktur a dokladů CSV, XLSX a ISDOC a balíček dokladů v PDF), a to i v Režimu pouze pro čtení a po zrušení předplatného.",
        },
        {
          text: "Po skončení Zkušební doby bez objednání Tarifu, po skončení předplatného nebo po skončení bezplatného přístupu zůstane Účet 12 měsíců v Režimu pouze pro čtení. Poté Poskytovatel Zákazníka e-mailem upozorní, že Účet a Data Zákazníka smaže, a smaže je nejdříve 30 dní po tomto upozornění, pokud si Zákazník mezitím neobjedná Tarif. Smazáním Účtu Smlouva zaniká.",
        },
        {
          text: "Smaže-li Zákazník Účet sám, Poskytovatel bez zbytečného odkladu, nejpozději do 30 dní, smaže Data Zákazníka v databázi a soubory dokladů a log, které Služba u Zákazníka eviduje; ze záloh zmizí v rámci jejich běžné obměny do dalších 30 dní. Soubory, které již nejsou přiřazeny k žádnému záznamu (například u dříve smazaných dokladů), touto cestou odstraněny být nemusí; Poskytovatel je odstraní do 30 dní na žádost zaslanou na [info@idex-corp.com](mailto:info@idex-corp.com). Data Organizace, ve které zůstávají jiní Uživatelé, zůstávají této Organizaci. Smazání je nevratné, proto si Zákazník data předem exportuje.",
        },
        {
          text: "Poskytovatel data pravidelně zálohuje. Zálohy slouží k obnově Služby po poruše, nikoli k obnově jednotlivých záznamů na žádost Zákazníka. Za uchování vlastních kopií Dat Zákazníka, zejména pro účely archivace podle právních předpisů, odpovídá Zákazník.",
        },
        {
          text: "Při zpracování osobních údajů obsažených v Datech Zákazníka je Zákazník správcem a Poskytovatel zpracovatelem; jejich vztah upravuje [Smlouva o zpracování osobních údajů](/dpa), která je součástí Smlouvy. Osobní údaje Uživatelů, které Poskytovatel zpracovává jako správce, popisují [Zásady ochrany osobních údajů](/privacy).",
        },
      ],
    },
    {
      title: "Služby třetích stran",
      clauses: [
        {
          text: "Služba využívá služby třetích stran, zejména rozhraní API Fio banky, a.s. (stahování pohybů), platební bránu Stripe (platby), Supabase (databáze, přihlášení, úložiště souborů a serverové funkce), Vercel (hosting a brána Vercel AI Gateway, přes kterou se doklady předávají ke zpracování modelu AI společnosti Google) a Cloudflare (ochrana formulářů, příjem e-mailů a zálohy). Úplný seznam zpracovatelů osobních údajů uvádějí [Zásady ochrany osobních údajů](/privacy).",
        },
        {
          text: "Za dostupnost a funkčnost služeb třetích stran, které Poskytovatel nemůže ovlivnit (zejména rozhraní API Fio banky a registru ARES), Poskytovatel neodpovídá. Změní-li třetí strana svou službu tak, že ji Služba nemůže dál využívat, postupuje se podle čl. 5.2.",
        },
        {
          text: "Volitelné integrace zapíná Zákazník sám. Jejich užívání se řídí také podmínkami jejich poskytovatelů.",
        },
        {
          text: "Uživatel může ke Službě připojit AI asistenta třetí strany (například Claude) přes konektor MCP. Připojení vyžaduje přihlášení do Služby a výslovné schválení Uživatelem, který zvolí jednu Organizaci a rozsah oprávnění: buď jen čtení, nebo i zápis (párování dokladů s platbami, kategorizace transakcí a změna stavu faktury). Asistent pak k Datům Zákazníka této Organizace přistupuje jménem Uživatele. Data, která asistent ze Služby získá, zpracovává jeho poskytovatel podle svých podmínek. Za kroky, které asistent v rámci uděleného oprávnění provede, odpovídá Zákazník jako za kroky Uživatele. Připojení lze kdykoli odvolat v nastavení Služby (Integrace); odvolání platí okamžitě.",
        },
      ],
    },
    {
      title: "Pravidla užívání",
      clauses: [
        {
          text: "Zákazník ani Uživatelé nesmějí:",
          items: [
            "užívat Službu v rozporu s právními předpisy, zejména k vystavování nepravdivých dokladů, ke krácení daní nebo k legalizaci výnosů z trestné činnosti;",
            "nahrávat obsah, k jehož užití nemají právo, nebo škodlivý kód;",
            "pokoušet se o neoprávněný přístup k datům jiných zákazníků nebo k systémům Poskytovatele, obcházet zabezpečení, limity Tarifu nebo jiná technická omezení;",
            "nadměrně zatěžovat Službu, zejména automatizovaným stahováním dat mimo rozhraní, která k tomu Služba nabízí (export, konektor MCP);",
            "sdílet přihlašovací údaje, zpřístupňovat Účet třetím osobám jinak než přizváním Uživatelů nebo Službu dále prodávat či poskytovat jiným jako vlastní službu;",
            "provádět zpětnou analýzu nebo dekompilaci Služby, ledaže to výslovně dovoluje zákon.",
          ],
        },
        {
          text: "Zákazník chrání přihlašovací údaje svých Uživatelů a podezření na zneužití Účtu oznámí Poskytovateli bez zbytečného odkladu.",
        },
      ],
    },
    {
      title: "Pozastavení a ukončení Smlouvy",
      clauses: [
        {
          text: "Poskytovatel může přístup k Účtu nebo k části Služby dočasně pozastavit, je-li to nezbytné k odvrácení bezpečnostního rizika nebo újmy jiným zákazníkům či Poskytovateli, nebo při důvodném podezření na podstatné porušení Podmínek. O pozastavení a jeho důvodu Zákazníka bez zbytečného odkladu informuje a pozastavení zruší, jakmile důvod pomine.",
        },
        {
          text: "Poruší-li Zákazník Podmínky podstatně (zejména čl. 12) a nezjedná-li nápravu ani v přiměřené lhůtě, nejméně 7 dní od výzvy, nebo nelze-li porušení napravit, může Poskytovatel od Smlouvy odstoupit s okamžitou účinností. Zaplacená cena se v takovém případě nevrací. Nebrání-li tomu zákon nebo bezpečnostní důvody, umožní Poskytovatel Zákazníkovi ještě 30 dní po odstoupení export Dat Zákazníka. Neuhrazení ceny se řeší podle čl. 8.4, nikoli odstoupením.",
        },
        {
          text: "Poskytovatel může Smlouvu vypovědět i bez udání důvodu s výpovědní dobou 3 měsíce, například při ukončení Služby. Zákazníkovi vrátí poměrnou část předem zaplacené ceny za období po zániku Smlouvy.",
        },
        {
          text: "Zákazník může Smlouvu ukončit kdykoli smazáním Účtu (čl. 9.5), a dále v případech podle čl. 5.2 a 16.3.",
        },
        {
          text: "Zánik Smlouvy se nedotýká ustanovení, která podle své povahy mají trvat i po jejím zániku, zejména čl. 10, 15 a 17.",
        },
      ],
    },
    {
      title: "Duševní vlastnictví a licence",
      clauses: [
        {
          text: "Služba, zejména její software, vzhled, databáze a označení včetně názvu a loga Zettl, je chráněna právy duševního vlastnictví, která náleží Poskytovateli nebo jeho poskytovatelům licencí.",
        },
        {
          text: "Poskytovatel uděluje Zákazníkovi na dobu trvání Smlouvy nevýhradní a nepřevoditelnou licenci užívat Službu pro potřeby jeho podnikání v rozsahu Tarifu a Podmínek, bez práva udělit podlicenci. Uživatelé ji užívají jménem Zákazníka. Odměna za licenci je zahrnuta v ceně Tarifu; během Zkušební doby a při bezplatném přístupu je licence bezúplatná.",
        },
        {
          text: "Zákazník uděluje Poskytovateli oprávnění Data Zákazníka ukládat, zpracovávat, zobrazovat a předávat zpracovatelům v rozsahu nezbytném k poskytování Služby.",
        },
        {
          text: "Návrhy a připomínky ke Službě, které Zákazník Poskytovateli zašle, může Poskytovatel bezplatně využít ke zlepšení Služby.",
        },
      ],
    },
    {
      title: "Odpovědnost",
      clauses: [
        {
          text: "Vady Služby (například chybnou funkci nebo nedostupnost) Zákazník oznamuje bez zbytečného odkladu na [info@idex-corp.com](mailto:info@idex-corp.com). Poskytovatel je odstraní v přiměřené lhůtě.",
        },
        {
          text: "Poskytovatel neodpovídá za újmu vzniklou:",
          items: [
            "chybným nebo neúplným výsledkem čtení dokladů nebo párování, který Zákazník v rozporu s čl. 5.4 nezkontroloval;",
            "chybnými nebo neúplnými daty od třetích stran, zejména z rozhraní API Fio banky, z registru ARES nebo z nahraných dokladů;",
            "nedostupností Služby nebo služeb třetích stran v případech podle čl. 5.3 a 11.2;",
            "zneužitím přihlašovacích údajů nebo tokenu Fio banky na straně Zákazníka nebo jednáním AI asistenta, kterého Zákazník připojil (čl. 11.4);",
            "účetními, daňovými a jinými rozhodnutími Zákazníka.",
          ],
        },
        {
          text: "Poskytovatel nenahrazuje ušlý zisk, ztrátu obchodní příležitosti ani nepřímou nebo následnou škodu.",
        },
        {
          text: "Celková náhrada újmy, kterou Poskytovatel Zákazníkovi poskytne ze všech škodních událostí souvisejících se Smlouvou, je omezena částkou, kterou Zákazník Poskytovateli za Službu zaplatil během 12 měsíců před vznikem škodní události. Nezaplatil-li Zákazník dosud nic (například během Zkušební doby nebo při bezplatném přístupu), je omezena částkou 1 000 Kč. Strany považují toto omezení s ohledem na cenu Služby a na všechny okolnosti za přiměřené.",
        },
        {
          text: "Omezení a vyloučení odpovědnosti podle tohoto článku se nepoužijí na újmu způsobenou úmyslně nebo z hrubé nedbalosti, na újmu na přirozených právech člověka (§ 2898 občanského zákoníku) ani v jiných případech, kdy je zákon nepřipouští.",
        },
      ],
    },
    {
      title: "Změny Podmínek",
      clauses: [
        {
          text: "Poskytovatel může Podmínky v přiměřeném rozsahu měnit (§ 1752 občanského zákoníku), zejména z důvodu změny Služby nebo Tarifů, právních předpisů nebo bezpečnosti.",
        },
        {
          text: "Změnu Poskytovatel oznámí Zákazníkovi e-mailem a ve Službě nejméně 30 dní před její účinností, se shrnutím hlavních změn a s odkazem na nové znění.",
        },
        {
          text: "Zákazník má právo změnu odmítnout a Smlouvu z tohoto důvodu vypovědět. Výpověď musí Poskytovateli doručit e-mailem před účinností změny; Smlouva pak zanikne dnem předcházejícím dni účinnosti změny. Poskytovatel Zákazníkovi vrátí poměrnou část předem zaplacené ceny za období po zániku Smlouvy.",
        },
        {
          text: "Neodmítne-li Zákazník změnu do její účinnosti, platí, že ji přijal.",
        },
        {
          text: "Změny výhradně ve prospěch Zákazníka a změny čistě formální (například oprava překlepu nebo kontaktních údajů) mohou nabýt účinnosti již zveřejněním.",
        },
      ],
    },
    {
      title: "Závěrečná ustanovení",
      clauses: [
        {
          text: "Smlouva a Podmínky se řídí právním řádem České republiky s vyloučením jeho kolizních norem.",
        },
        {
          text: "Spory ze Smlouvy rozhodují soudy České republiky. Strany podle § 89a občanského soudního řádu sjednávají, že místně příslušným soudem je soud příslušný podle sídla Poskytovatele.",
        },
        {
          text: "Podmínky jsou vyhotoveny v českém jazyce. Překlad do angličtiny má jen informativní povahu; v případě rozporu má přednost české znění.",
        },
        {
          text: "Zákazník nemůže Smlouvu ani práva z ní postoupit bez souhlasu Poskytovatele. Zákazník souhlasí, že Poskytovatel může Smlouvu postoupit na nabyvatele Služby nebo její podstatné části; o postoupení Zákazníka předem informuje.",
        },
        {
          text: "Je-li některé ustanovení Podmínek neplatné nebo neúčinné, ostatní ustanovení tím nejsou dotčena a strany je nahradí ustanovením, které se jeho účelu co nejvíce blíží.",
        },
        {
          text: "Dokud Poskytovatel nespustí placené Tarify, poskytuje Službu bezplatně a čl. 6 až 9 se nepoužijí. Spuštění placených Tarifů oznámí stávajícím Zákazníkům e-mailem nejméně 30 dní předem; jejich bezplatný přístup upravuje čl. 6.8.",
        },
        {
          text: "Tyto Podmínky ve verzi 2.0.1 byly zveřejněny dne 25. října 2026. Od verze 2.0 zveřejněné dne 23. října 2026 se liší jen formálními úpravami (adresa Služby, popis registrace a vypuštění integrace Google Drive, která již není součástí Služby), které podle čl. 16.5 nabývají účinnosti zveřejněním. Na smlouvy uzavřené po zveřejnění verze 2.0 se tyto Podmínky vztahují ode dne uzavření smlouvy. Na Zákazníky, kteří Smlouvu uzavřeli dříve, se vztahují ode dne 15. listopadu 2026 a do té doby pro ně platí Podmínky užití platformy Zettl účinné od 21. března 2026, které Poskytovatel na požádání zašle.",
        },
      ],
    },
  ],
  contactLabel: "Kontakt:",
  closingPlaceDate: "V Praze dne 25. října 2026",
};
